import React from "react";
import  { useSelector } from "react-redux";
import { ProgressIndicator } from "rhombus-react";

import useActiveCreative from "hooks/useActiveCreative";
import CreativesTable from "widgets/table/CreativesTable";

import "./DeleteCreatives.css";

export default function DeleteCreatives({ creatives }) {
	const isDeleting = useSelector(state => state.creatives.isDeleting);
	let message = 'Are you sure you want to delete the selected creative?';
	if (creatives.length > 1) {
		message = 'Are you sure you want to delete the selected creatives?';
	}

	useActiveCreative(creatives[0]?.id);

	return (
		<div className="delete-creative-modal">
			<ProgressIndicator isLoading={isDeleting} />
			<strong className="status-header">{message}</strong>
			<CreativesTable creatives={creatives} shouldLinkPreview={false} />
		</div>
	);
}

DeleteCreatives.displayName = "DeleteCreatives";
DeleteCreatives.defaultProps = {
	creatives: [],
};
